export default "__VITE_ASSET__CdVv5ifw__"